/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-var-requires */
import * as React from "react";
import { Box } from "@material-ui/core";

// const dummyImg = require("../../images/dummyImage.png");
// const bellIconImg = require("../../images/bellIcon.png");

export function Header() {
  const { HeaderStyle, Title, vertical, Menu, hr } = headerStyle;
  return (
    <div>
      <div style={HeaderStyle}>
        <Box display={{ xs: "none", sm: "block" }}>
          <h1 style={Title}>Toorak</h1>
        </Box>
        {/* <img style={image} src={dummyImg} alt="logo" /> */}
        <span style={vertical} />
        <p
          style={Menu}
          onClick={() => menuClicked("Dashboard")}
          onKeyDown={() => menuClicked("Dashboard")}
        >
          Dashboard
        </p>
        <p
          style={Menu}
          onClick={() => menuClicked("Loans")}
          onKeyDown={() => menuClicked("Loans")}
        >
          Loans
        </p>
        {/* <img style={bellIcon} src={bellIconImg} alt="bellIcon" /> */}
      </div>
      <hr style={hr} />
    </div>
  );
}

const menuClicked = (menu: string) => {
  // eslint-disable-next-line no-console
  console.log(menu);
};

const headerStyle = {
  Title: {
    fontFamily: "Arial",
    width: "20%"
  },
  HeaderStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    height: "50px",
    padding: "10px 15px"
  } as any,
  Menu: {
    margin: "0px 10px"
  },
  hr: {
    marginTop: "0px"
  },
  vertical: {
    borderLeft: "1px solid lightgrey",
    height: "70px"
  },
  image: {
    height: "100px"
  },
  bellIcon: {
    marginLeft: "auto",
    height: "30px"
  }
};
